import { type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { CommandPalette } from '../ui/CommandPalette';
import { InstallPrompt } from '../pwa/InstallPrompt';
import { BroadcastBanner } from './BroadcastBanner';
import { FirstRun } from '../onboarding/FirstRun';

// Note: VerticalProvider should likely wrap the entire App in App.tsx, 
// ensuring data is available before Layout renders.

export const DashboardLayout = ({ children }: { children: ReactNode }) => {
    return (
        <div className="min-h-screen bg-canvas fd-canvas-glow text-fg-2 font-sans antialiased">
            {/* One soft pool of light at the top of the canvas (theme.css,
                .fd-canvas-glow), scrolling with the page. Not a fixed mesh
                behind every card — that is what once made cards look lit
                from behind. Selection colour is global (index.css). */}

            <Sidebar />

            {/* Main Content Area */}
            {/* Bottom padding clears the mobile nav (4rem) plus the home-indicator
                inset; top padding clears the notch, because the iOS status bar is
                translucent (see apple-mobile-web-app-status-bar-style in index.html). */}
            <main className="lg:pl-[220px] min-h-screen pb-[calc(6rem+env(safe-area-inset-bottom))] lg:pb-0 transition-all duration-300">
                <div className="fd-page">
                    <BroadcastBanner />
                    {children}
                </div>
            </main>

            <MobileNav />
            <CommandPalette />
            <InstallPrompt />
            <FirstRun />
        </div>
    );
};
